import React from 'react';
import LogoContext from '../LogoContext';

export default function LogoProvider(props) {
  const { children } = props;
  return <LogoContext.Provider>{children}</LogoContext.Provider>;
}
